import { post } from '@http/request'

export const orderListAPI = {
  reqDHLExport: reqData => post(`/vip/order/international/asyInterOutExportOrder`, reqData)
}
